import { parse, isValid, format, parseISO, parseJSON  } from 'date-fns';
var formatDistance = require('date-fns/formatDistance');
var formatDistanceToNow = require('date-fns/formatDistanceToNow');
(function (tactic, $, undefined) {
    //wiht history
    tactic.historyRedirect = function (url) {
        window.location.href = url;
    };
    //without history
    tactic.redirect = function (url) {
        window.location.replace(url);
    };
    tactic.isNullOrWhiteSpace = function (input) {
        return !input || !input.trim();
    };
    tactic.forgeryToken = function () {
        return kendo.antiForgeryTokens();
    };
    tactic.addAntiForgeryToken = function (data) {
        data.__RequestVerificationToken = kendo.antiForgeryTokens().__RequestVerificationToken;
        return data;
    };
    tactic.getSelectedText = function () {
        var $selectedText = "";
        if (window.getSelection) {
            $selectedText = window.getSelection();
        } else if (document.getSelection) {
            $selectedText = document.getSelection();
        } else if (document.selection) {
            $selectedText = document.selection.createRange().text;
        }
        if ($selectedText !== "") {
            $selectedText = $selectedText.toString();
        }
        return $selectedText;

    };
    tactic.updateDateTimeFields = function (ctrl) {
        $(".active-text-date").each(function () {
            var date = $(this).text().trim();
            if (date !== null && date !== '' && date !== 'null' && date !== undefined) {
                var dte = parseISO(date);
                if (isValid(dte)) {
                    var formatted = format(dte, "MM/dd/yyyy");
                    $(this).text(formatted);
                }
            }
            else {
                $(this).text("");
            }
        });
        $(".active-text-date-time").each(function () {
            var date = $(this).text().trim();
            if (date !== null && date !== '' && date !== 'null' && date !== undefined) {
                var dte = parseISO(date);
                if (isValid(dte)) {
                    var formatted = format(dte, "MM/dd/yyyy h:m aaa");
                    $(this).text(formatted);
                }
            }
            else {
                $(this).text("");
            }
        });
        $(".active-text-date-time-seconds").each(function () {
            var date = $(this).text().trim();
            if (date !== null && date !== '' && date !== 'null' && date !== undefined) {
                var dte = parseISO(date);
                if (isValid(dte)) {
                    var formatted = format(dte, "MM/dd/yyyy h:m:s aaa");
                    $(this).text(formatted);
                }
            }
            else {
                $(this).text("");
            }
        });
        $(".active-text-date-ago").each(function () {
            var date = $(this).text().trim();
            if (date !== null && date !== '' && date !== 'null' && date !== undefined) {
                var dte = parseISO(date);
                if (isValid(date)) {
                    var formatted = formatDistanceToNow(parseISO(date));
                    $(this).text(formatted);
                }
            }
            else {
                $(this).text("");
            }
        });
        $(".active-text-date-month-day").each(function () {
            var date = $(this).text().trim();
            if (date !== null && date !== '' && date !== 'null' && date !== undefined) {
                var dte = parseISO(date);
                if (isValid(dte)) {
                    var formatted = format(dte, "MMM Do");
                    $(this).text(formatted);
                }
            }
            else {
                $(this).text("");
            }
        });

    };
    tactic.documentReady = function () {
        $(".character-countdown").keyup(function () {
            var txt = $(this);
            var target = txt.data("target-label");
            var maxLength = txt.attr("maxlength");
            if (target !== undefined && maxLength !== undefined) {
                var length = txt.val().length;
                length = maxLength - length;
                $('#' + target).text(String(length) + " characters left");
            }
        });
    };
    tactic.setInitalTimePicker = function (e) {
        if (!e.sender.value()) { // Run only if no value was selected
            setTimeout(() => {
                let containerElement = e.sender.timeView.list;
                let listElement = containerElement.children().first();
                containerElement.scrollTop(listElement.height() * 8 / 24)
            }, 0);
        }

    };
    tactic.renderHtml = function (s) {
        var parser = new DOMParser();
        var str = parser.parseFromString(s, "text/html");
        return str.body.innerHTML;
    };
    tactic.passwordStrength = function (element, password) {
        var desc = [{ 'width': '0px' }, { 'width': '20%' }, { 'width': '40%' }, { 'width': '60%' }, { 'width': '80%' }, { 'width': '100%' }];
        var descClass = ['', 'progress-bar progress-bar-danger', 'progress-bar progress-bar-danger', 'progress-bar progress-bar-warning', 'progress-bar progress-bar-success', 'progress-bar progress-bar-success'];
        var score = 0;

        if (password.length > 6) {
            score++;
        }

        if ((password.match(/[a-z]/)) && (password.match(/[A-Z]/))) {
            score++;
        }

        if (password.match(/\d+/)) {
            score++;
        }

        if (password.match(/.[!,@,#,$,%,^,&,*,?,_,~,-,(,)]/)) {
            score++;
        }

        if (password.length > 10) {
            score++;
        }

        element.removeClass();
        element.addClass(descClass[score]).css(desc[score]);
    };
    tactic.urlHelper = function (url, ...args) {
        return decodeURI(url).format(...args);
    };
}(window.tactic = window.tactic || {}, jQuery));
var defaultLoadingText = '<i class=\"fa fa-spinner fa-spin\"></i> Processing...';
////////////////////////////////////////
// BEGIN JavaScript Extensions
////////////////////////////////////////

// Extending the string type with a c# style format function
if (!String.prototype.format) {
    String.prototype.format = function () {
        var args = arguments;
        return this.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != "undefined" ? args[number] : match;
        });
    };
}
if (!Array.prototype.remove) {
    Array.prototype.remove = function () {
        var what, a = arguments, L = a.length, ax;
        while (L && this.length) {
            what = a[--L];
            while ((ax = this.indexOf(what)) !== -1) {
                this.splice(ax, 1);
            }
        }
        return this;
    };
}